import { Navigate, useParams } from 'react-router-dom'

export default function PortalLogin() {
  const { slug } = useParams()
  return <Navigate to={slug ? `/auth?org=${slug}` : '/auth'} replace />
}
